var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from './admin.service';
import { UserService } from './user.service';
import { AppSettings } from './../app.settings';
import { SidekickService } from './sidekick.service';
var AuthGuardService = /** @class */ (function () {
    function AuthGuardService(router, cookieService, toastr, adminService, sideKickService, userService) {
        this.router = router;
        this.cookieService = cookieService;
        this.toastr = toastr;
        this.adminService = adminService;
        this.sideKickService = sideKickService;
        this.userService = userService;
    }
    // Checking whether user can enter main page
    // Both Authentication & Subscription are required for canActivate
    AuthGuardService.prototype.canActivate = function () {
        var _this = this;
        // Handle function after checking authentication and subscription
        var handle = function (isAuth, hasSub) {
            if (isAuth && hasSub) {
                console.log('authenticated & subscribed.');
                return true;
            }
            else {
                console.log('auth failed');
                _this.router.navigate(['auth/login'], {
                    queryParamsHandling: 'merge'
                }); // To keep socket sidekick params
                // Alert user there is no subscription of this app
                if (isAuth && (!hasSub)) {
                    _this.toastr.error('No Subscription.');
                }
                return false;
            }
        };
        return new Promise(function (resolve) {
            console.log('Checking Auth...');
            // Different auth checks for different accessing portal
            var checkPromise;
            switch (AppSettings.loginPortal) {
                case 'LBPortal':
                    checkPromise = _this.lbPortalAuthCheck();
                    break;
                case 'AZPortal':
                default:
                    checkPromise = _this.azPortalAuthCheck();
            }
            checkPromise.then(function (info) {
                resolve(handle(info.isAuthenticated, info.hasSubscription));
            });
            // // Default: no authentication nor subscription
            // const info = {
            // 	isAuthenticated: false,
            // 	hasSubscription: false
            // };
            // // Check authentication first
            // if (!this.userService.isTokenExpired()) {
            // 	// Token exists => app is authenticated
            // 	info.isAuthenticated = true;
            // 	// Check subscription if authenticated
            // 	this.adminService.getUserSubscription(this.userService.getUserInfo().userEmail, (rsp) => {
            // 		// Has subscription
            // 		if (rsp.data && rsp.data[0]) {
            // 			info.hasSubscription = true;
            // 			// Update userInfo with subscription info
            // 			this.userService.updateUserInfoFromUserSub(rsp.data[0]);
            // 		}
            // 		resolve(handle(info.isAuthenticated, info.hasSubscription));
            // 	}, (err) => {
            // 		resolve(handle(info.isAuthenticated, info.hasSubscription));
            // 	});
            // } else {
            // 	resolve(handle(info.isAuthenticated, info.hasSubscription));
            // }
        });
    };
    // Authentication check for AZPortal
    AuthGuardService.prototype.azPortalAuthCheck = function () {
        var _this = this;
        return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
            var info, userSubs, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        info = {
                            isAuthenticated: false,
                            hasSubscription: false
                        };
                        if (!!this.userService.isTokenExpired()) return [3 /*break*/, 5];
                        // Token exists => app is authenticated
                        info.isAuthenticated = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.adminService.getUserSubscription(this.userService.getUserInfo().userEmail)];
                    case 2:
                        userSubs = _a.sent();
                        // Has subscription
                        if (userSubs[0]) {
                            info.hasSubscription = true;
                            // Update userInfo with subscription info
                            this.userService.updateUserInfoFromUserSub(userSubs[0]);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 4];
                    case 4:
                        resolve(info);
                        return [3 /*break*/, 6];
                    case 5:
                        resolve(info);
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); });
    };
    // Authentication check for LBPortal
    AuthGuardService.prototype.lbPortalAuthCheck = function () {
        var _this = this;
        return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
            var info, authCookieName, tokenCookie, userSubs, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        info = {
                            isAuthenticated: false,
                            hasSubscription: false
                        };
                        if (!!this.userService.isTokenExpired()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.userService.setUpdatedToken(this.userService.getCurrentToken())];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        // Check token from url
                        this.sideKickService.checkTokenParam();
                        if (!this.sideKickService.tokenParam) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.userService.setUpdatedToken(this.sideKickService.tokenParam)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!this.userService.isTokenExpired()) return [3 /*break*/, 6];
                        authCookieName = 'PortalToken';
                        tokenCookie = this.cookieService.get(authCookieName);
                        if (!tokenCookie) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.userService.setUpdatedToken(tokenCookie)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        if (!!this.userService.isTokenExpired()) return [3 /*break*/, 11];
                        // Token exists => app is authenticated
                        info.isAuthenticated = true;
                        _a.label = 7;
                    case 7:
                        _a.trys.push([7, 9, , 10]);
                        return [4 /*yield*/, this.adminService.getUserSubscription(this.userService.getUserInfo().userEmail)];
                    case 8:
                        userSubs = _a.sent();
                        // Has subscription
                        if (userSubs[0]) {
                            info.hasSubscription = true;
                            // Update userInfo with subscription info
                            this.userService.updateUserInfoFromUserSub(userSubs[0]);
                        }
                        return [3 /*break*/, 10];
                    case 9:
                        err_2 = _a.sent();
                        console.log(err_2);
                        return [3 /*break*/, 10];
                    case 10:
                        resolve(info);
                        return [3 /*break*/, 12];
                    case 11:
                        resolve(info);
                        _a.label = 12;
                    case 12: return [2 /*return*/];
                }
            });
        }); });
    };
    return AuthGuardService;
}());
export { AuthGuardService };
